import React from "react";
import { desktopSoftwareServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const DesktopSoftwareServiceDetailPage = () => {
  const data = desktopSoftwareServiceData;
  return (
    <>
      <SEO {...seoData.desktopSoftware} />
      <ServiceDetailsInner data={data} />
    </>
  );
};

export default DesktopSoftwareServiceDetailPage;
